import { LibraryCache } from 'base/library_cache';
import { extractSimpleSectionState } from 'base/react_integrations';
import { Section } from 'blocks/editor/model';
import React from 'react';

type ContentState =
  | {
      state: 'loading';
      promise: Promise<unknown>;
    }
  | {
      state: 'ready';
      element: React.ReactElement | null;
    };

async function renderSection(section: Section, library: LibraryCache) {
  const viewer = await import('components/viewer');
  if (!viewer.supportsSection(section.element.current?.source.slug ?? '')) {
    return null;
  }
  const simpleSectionState = await extractSimpleSectionState(
    section.state,
    library,
  );
  if (simpleSectionState) {
    return viewer.render(simpleSectionState);
  }
  return null;
}

export function Section({
  section,
  library,
}: {
  section: Section;
  library: LibraryCache;
}) {
  const [content, setContent] = React.useState<ContentState>();
  React.useEffect(() => {
    const promise = renderSection(section, library)
      .then((result) => {
        setContent({
          state: 'ready',
          element: result,
        });
      })
      .catch((error) => {
        setContent({
          state: 'ready',
          element: <div>Error rendering section</div>,
        });
        console.error(error);
      });
    setContent({ state: 'loading', promise });
  }, [section, library]);

  if (content?.state === 'loading') {
    throw content.promise;
  }
  return content?.element ?? null;
}
